import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=7df02c76&scoped=true&lang=pug&"
import script from "./VideoCall.vue?vue&type=script&lang=js&"
export * from "./VideoCall.vue?vue&type=script&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=7df02c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df02c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df02c76')) {
      api.createRecord('7df02c76', component.options)
    } else {
      api.reload('7df02c76', component.options)
    }
    module.hot.accept("./VideoCall.vue?vue&type=template&id=7df02c76&scoped=true&lang=pug&", function () {
      api.rerender('7df02c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/components/VideoCall.vue"
export default component.exports